/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartsignindifferentsuffix5Inputs */

const en_authstartsignindifferentsuffix5 = /** @type {(inputs: Authstartsignindifferentsuffix5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— your funnel answers stay tied to the email above.`)
};

const pt_authstartsignindifferentsuffix5 = /** @type {(inputs: Authstartsignindifferentsuffix5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— as respostas do funil ficam ligadas ao email acima.`)
};

/**
* | output |
* | --- |
* | "— your funnel answers stay tied to the email above." |
*
* @param {Authstartsignindifferentsuffix5Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartsignindifferentsuffix5 = /** @type {((inputs?: Authstartsignindifferentsuffix5Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartsignindifferentsuffix5Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartsignindifferentsuffix5(inputs)
	return pt_authstartsignindifferentsuffix5(inputs)
});
export { authstartsignindifferentsuffix5 as "authStartSignInDifferentSuffix" }